export const NAME_PLACEHOLDER_VALUE = 'Clint Eastwood'
